/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type ExternalAgentApplicationStatus =
  (typeof ExternalAgentApplicationStatus)[keyof typeof ExternalAgentApplicationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalAgentApplicationStatus = {
  applied: 'applied',
  already_applied: 'already_applied',
  pending: 'pending',
} as const;
